import { render, staticRenderFns } from "./EditInsurance.vue?vue&type=template&id=d676c57e&"
import script from "./EditInsurance.vue?vue&type=script&lang=js&"
export * from "./EditInsurance.vue?vue&type=script&lang=js&"
import style0 from "./EditInsurance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports